const GlobalStyles = {
  '*': { boxSizing: 'border-box' },
  body: { margin: 0, padding: 0, fontFamily: 'Roboto, Arial, sans-serif' },
}

export default GlobalStyles
